import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Badge,
  Drawer
} from '@material-ui/core'
import MenuRoundedIcon from '@material-ui/icons/MenuRounded'
import CloseRoundedIcon from '@material-ui/icons/CloseRounded'
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import useStyles from './styles'
import history from 'browserHistory'
import SearchRequestAdvice from 'components/SearchRequestAdvice'
import AddAdviceModal from 'components/AddAdviceModal'
import MobileSearchOrRequestAdvice from 'components/MobileSearchOrRequestAdvice'
import CommonNotificationsList from 'components/CommonNotificationsList'
import { userIsAdmin } from 'helpers/dataHelpers'
import { getUnreadCommonNotifications } from 'utils/notifications/actions'
import { ReactComponent as VisiawLogoText } from 'static/icons/logo-text.svg'
import { ReactComponent as SearchIcon } from 'static/icons/search.svg'
import { ReactComponent as BellIcon } from 'static/icons/bell.svg'


const Navbar = (props) => {
  const { classes, handleDrawerOpen } = props
  const localClasses = useStyles()
  const dispatch = useDispatch()
  const userType = useSelector(state => state.auth.userType)
  const isDesktop = useSelector(state => state.common.isDesktop)
  const activeWorkspace = useSelector(state => state.auth.activeWorkspace)
  const notificationsUnreadCount = useSelector(state => state.notifications.notificationsUnreadCount)
  const requestsUnreadCount = useSelector(state => state.notifications.requestsUnreadCount)
  const commonNotificationsUnreadCount = useSelector(state => state.notifications.commonNotificationsUnreadCount)
  const [showAddAdviceModal, setShowAddAdviceModal] = useState(false)
  const [showSearch, setShowSearch] = useState(false)
  const [showNotifications, setShowNotifications] = useState(false)

  useEffect(() => {
    if (activeWorkspace) {
      dispatch(getUnreadCommonNotifications())
    }
  }, [activeWorkspace]) // eslint-disable-line react-hooks/exhaustive-deps

  const setAction = () => {
    return (userIsAdmin(userType) ?
      <SearchRequestAdvice disabled={activeWorkspace.in_invitation} isAdmin setShowAddAdviceModal={setShowAddAdviceModal} /> :
      <SearchRequestAdvice disabled={activeWorkspace.in_invitation} />
    )
  }

  const setTitle = () => {
    switch (true) {
      case history.location.pathname === '/':
        return 'Legal Updates'
      case history.location.pathname === '/advices':
        return 'Advices'
      case history.location.pathname.startsWith('/advices'):
        return 'Advices'
      case history.location.pathname === '/calendar':
        return 'Calendar'
      case history.location.pathname === '/documents':
        return 'Documents'
      case history.location.pathname === '/settings':
        return 'Settings'
      case history.location.pathname.startsWith('/laws'):
        return 'Laws'
      case history.location.pathname === '/notifications':
        return 'Notification center'
      case history.location.pathname.startsWith('/groups'):
        return 'Groups'
      case history.location.pathname.startsWith('/requests'):
        return 'Requests'
      case history.location.pathname.startsWith('/legal-updates'):
        return 'Legal Updates'
      case history.location.pathname.startsWith('/legal-change-collection'):
        return 'Legal Changes (Collection)'
      case history.location.pathname.startsWith('/legal-changes'):
        return 'Legal Changes'
      case history.location.pathname.startsWith('/action-plan'):
        return 'Action Plan'
      case history.location.pathname === '/test':
        return 'Test'
      default:
        return 'Legal Updates'
    }
  }

  return (
    <>
      {
        !isDesktop &&
          <>
            <AppBar
              position='fixed'
              color='transparent'
              className={localClasses.mobileAppBar}
            >
              <Toolbar
                disableGutters
                className={localClasses.mobileToolbar}
              >
                <IconButton edge='start' className={localClasses.menuButton} color='inherit' aria-label='menu' onClick={handleDrawerOpen}>
                    <Badge
                      invisible={!!notificationsUnreadCount && !!requestsUnreadCount}
                      color='error'
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      variant='dot'
                      className={localClasses.typeIcon}
                    >
                    <MenuRoundedIcon />
                  </Badge>
                </IconButton>
                <div className={localClasses.logoWrapper}>
                  <VisiawLogoText className={localClasses.logoWrapperText} />
                </div>
                <div className={localClasses.grow} />
                <IconButton edge='end' className={localClasses.searchButton} color='inherit' aria-label='search' onClick={() => setShowSearch(true)}>
                  <SearchIcon className={localClasses.searchIcon} />
                </IconButton>
              </Toolbar>
            </AppBar>
            <MobileSearchOrRequestAdvice
              disabled={activeWorkspace.in_invitation}
              isOpen={showSearch}
              setShowSearch={setShowSearch}
              isAdmin={userIsAdmin(userType)}
              setShowAddAdviceModal={setShowAddAdviceModal}
            />
          </>
      }
      <AppBar
        position='relative'
        color='transparent'
        className={`${classes.appBar} ${isDesktop ? '' : localClasses.secondaryMobile}`}
      >
        <Toolbar disableGutters>
          <Typography
            variant={isDesktop ? 'h3' : 'h6'}
            noWrap
            className={localClasses.title}
          >
            {
              setTitle()
            }
          </Typography>
          <div className={localClasses.grow} />
          {
            isDesktop ?
            <div className={localClasses.actionContainer}>
              {
                setAction()
              }
            </div> :
            null
          }
          <IconButton
            edge='start'
            className={localClasses.bellButton}
            color='inherit'
            aria-label='notifications'
            onClick={() => setShowNotifications(true)}
            disabled={activeWorkspace.in_invitation}
          >
            <Badge
              color='error'
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              className={localClasses.typeIcon}
              badgeContent={commonNotificationsUnreadCount > 0 && !activeWorkspace.in_invitation ? commonNotificationsUnreadCount : 0}
            >
              <BellIcon />
            </Badge>
          </IconButton>
        </Toolbar>
        {
          showAddAdviceModal &&
            <AddAdviceModal
              setShowDialog={setShowAddAdviceModal}
              showDialog={showAddAdviceModal}
            />
        }
      </AppBar>
      <Drawer
        className={localClasses.drawer}
        open={showNotifications}
        anchor='right'
        classes={{
          paper: localClasses.drawerPaper
        }}
        ModalProps={{
          onClose: () => setShowNotifications(false)
        }}
      >
        <Typography
          variant='h5'
          className={localClasses.notificationsTitle}
        >
          Notifications
          <IconButton
            className={localClasses.closeButton}
            color='inherit'
            aria-label='close-notifications'
            onClick={() => setShowNotifications(false)}
          >
            <CloseRoundedIcon />
          </IconButton>
        </Typography>
        <CommonNotificationsList
          setShowNotifications={setShowNotifications}
        />
      </Drawer>
    </>
  )
}

export default Navbar
